<div style="text-align: right;">
	<mat-icon class="close pointer" [mat-dialog-close]="true">close</mat-icon>
</div>
<h2 class="v_center red">
    <mat-icon>warning</mat-icon> {{ data.message | translate }}
</h2>
<p *ngIf="data.detailedMessage">
    <b>{{ data.detailedMessage | translate }}</b>
</p>
<span  *ngIf="data.trace">
    <span *ngIf="!trace_expanded" (click)="trace_expanded = !trace_expanded" class="pointer linked-inside">{{ 'buttons.more_details' | translate }} &#X25BC;</span>
    <span *ngIf="trace_expanded"  (click)="trace_expanded = !trace_expanded" class="pointer linked-inside">{{ 'buttons.less_details' | translate }} &#X25B2;</span>
</span>
<p class="pre form_note" *ngIf="trace_expanded">{{ data.trace }}</p>